let acl_routes = [
  {
    path: '/',
    component: () => import('Modules/Dashboard/resources/layout/DashboardLayout.vue'),
    meta: {isPublicRoute: false},
    children: [
      { path: 'acl', name: 'acl.list', component: () => import('./pages/Index.vue') },
      { path: 'acl/create', name: 'acl.create', component: () => import('./pages/Create.vue') },
      { path: 'acl/:id/edit', name: 'acl.edit', component: () => import('./pages/Edit.vue') }
    ]
  }
];

export default acl_routes;
